export default __webpack_public_path__ + "static/media/afro-hair.36cbde88.png";